import { styled } from "@material-ui/core";

export const Benefits = styled("div")({
  backgroundColor: "#F5F5F5",
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  padding: "0 24px",
});

export const Scroll = styled("div")({
  height: "170px",
  overflowY: "auto",
  paddingRight: "20px",
});

export const Benefit = styled("div")({
  padding: "20px 20px 20px 0",
  position: "relative",

  "&:nth-child(-n+3)": {
    borderBottom: "1px solid #E2E2E2",
  },

  "&:nth-child(3)": {
    "&::before": {
      width: "0",
    },
  },

  "&::before": {
    backgroundColor: "#E2E2E2",
    content: '""',
    width: "1px",
    position: "absolute",
    top: "20px",
    bottom: "20px",
    right: "20px",
  },

  "& ul": {
    borderBottom: "1px solid #eee",
    marginBottom: "10px",
    paddingBottom: "10px",

    "& li": {
      color: "#929FAD",
      fontSize: "12px",
      padding: "2px 0",
      display: "flex",
      justifyContent: "space-between",
      whiteSpace: "initial",

      "& span": {
        minWidth: "60px",
        textAlign: "right",
      },
    },
  },
});

export const Icon = styled("span")({
  display: "block",
});

export const Title = styled("span")({
  color: "#4B5D72",
  display: "block",
  marginBottom: "10px",
});
